import 'core-js/stable';
import '../../helpers/polyfills';
import cssVars from 'css-vars-ponyfill';
import { configure } from 'mobx';
import { BrowserDetect } from '../../helpers/browserDetect';

cssVars();
configure({
  enforceActions: 'always',
  useProxies: !BrowserDetect.browser || BrowserDetect.browser === 'Explorer' ? 'never' : 'always',
});

require('./Connect.jsx');
